import { render } from "./UserCreate.vue?vue&type=template&id=98427bae"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"
script.render = render

export default script